module.exports = __webpack_public_path__ + "img/code-mh.9bd8c98f.png";